import request from './request'

export const getShopList = (params) => {
  return request({
    url: '/admin/shops',
    method: 'get',
    params
  })
}

export const getShopDetail = (id) => {
  return request({
    url: `/admin/shops/${id}`,
    method: 'get'
  })
}

export const createShop = (data) => {
  return request({
    url: '/admin/shops',
    method: 'post',
    data
  })
}

export const updateShop = (id, data) => {
  return request({
    url: `/admin/shops/${id}`,
    method: 'put',
    data
  })
}

export const deleteShop = (id) => {
  return request({
    url: `/admin/shops/${id}`,
    method: 'delete'
  })
}

export const adjustShopBalance = (id, data) => {
  return request({
    url: `/admin/shops/${id}/adjust-balance`,
    method: 'post',
    data
  })
}

export const approveShop = (id) => {
  return request({
    url: `/admin/shops/${id}/approve`,
    method: 'put'
  })
}

export const rejectShop = (id, remark = '') => {
  return request({
    url: `/admin/shops/${id}/reject`,
    method: 'put',
    data: { remark }
  })
}

// 获取店家推广人列表（用于下拉选择）
export const getShopReferrerOptions = (params) => {
  return request({
    url: '/admin/shop-referrers',
    method: 'get',
    params
  })
}

// 获取某店家已关联的推广人关系
export const getShopReferrerRelations = (shopId, params) => {
  return request({
    url: '/admin/shop-referrer-shops',
    method: 'get',
    params: { shop_id: shopId, ...params }
  })
}

// 为店家添加推广人
export const addShopReferrer = (shopId, shopReferrerId) => {
  return request({
    url: '/admin/shop-referrer-shops',
    method: 'post',
    data: { shop_id: shopId, shop_referrer_id: shopReferrerId }
  })
}

// 移除店家推广人关系
export const removeShopReferrer = (relationId) => {
  return request({
    url: `/admin/shop-referrer-shops/${relationId}`,
    method: 'delete'
  })
}
